/**
 * Converts camelCase string to capitalized words with spaces
 * @param {string} str - The camelCase string to convert
 * @returns {string} - The capitalized string with spaces
 */
export const capitalizeCamelCase = (str) => {
  if (!str) return '';
  
  // Add space before capital letters and capitalize first letter
  let result = str.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
  
  // Handle camelCase words properly
  result = result.replace(/([a-z])([A-Z])/g, '$1 $2');
  
  return result;
};
